import { createSelector } from 'reselect'

import { locationSelector } from 'utilities/routes'

import { NAME } from './constants'
import { initialState } from './reducer'

export const stateSelector = state => state.get(NAME) || initialState

export const fetchedSelector = createSelector(stateSelector, state =>
  state.get('fetched'),
)

export const initialValuesSelector = createSelector(stateSelector, state =>
  state.get('initialValues'),
)

export default createSelector(
  stateSelector,
  locationSelector,
  (state, location) => ({
    signupType: location.type,
    ...state.toJS(),
  }),
)



// WEBPACK FOOTER //
// ../source/views/Signup/selectors.js